import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import Stack from '@mui/material/Stack';

import { bio_auth } from '../linkMobile/bio';
import { toast } from 'react-toastify';
import { decryptData } from '@/lib/Cryptos';
import { localSetStorage, loginLocalStorage } from '@/lib/storage';
import { pinLogin } from '../users/login';
import ErrorRes from '@/api/server/ErrorRes';
import { useAuthInfoActions } from '@/store/zustand/store';
import { loginProps } from '@/api/server/user/read';
import { updatePushToken } from '@/api/server/user/update';
import { useCacheBuster } from 'react-cache-buster';
import { keepEmail } from '../users/common/keepEmail';
import { useTranslation } from 'react-i18next';

function LoginOtherDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { setAuthInfo } = useAuthInfoActions();

  const bioType = useRef(''); // check || auth || done
  const { checkCacheStatus } = useCacheBuster();

  window.appInterFace = (val: any, data?: any) => {
    bioInterFace(val, data);
  };
  const bioInterFace = (val: any, data?: any) => {
    if (bioType.current === 'auth') {
      // 1:인증성공,2:인증등록성공(안드로이드용),0:인증실패
      if (val === '1' || val === '2') {
        // toast.success('성공'); //넘어온 인증값 확인
        console.log(`data: ${JSON.stringify(data)}`);
        const re = bioResult(data);
        if (!re.pin_pw) {
          toast.error(`${t('toast.missingRequest')}`);
        }
        bioLogin(re);
      } else {
        toast.error(`${t('toast.authFail')}`);
      }
    }
  };
  const bioAuth = () => {
    bioType.current = 'auth';
    bio_auth(false);
  };
  const bioResult = (data: any) => {
    const email = loginLocalStorage().email;
    if (!email) {
      toast.error(`${t('toast.accessAftherIdPw')}`);
    }

    const res = setDecrypt({ email, value: data.key1 });
    console.log(`decrypt: ${res}`);
    return { email, pin_pw: res };
  };
  const setDecrypt = ({ email, value }: { email: string; value: string }): string => {
    const key = process.env.REACT_APP_CRYPTO_SOLT + email;
    console.log(`key: ${key}`);
    console.log(`value: ${value}`);
    const res: string = decryptData(value, key);
    console.log(`decrypt: ${res}`);
    return res;
  };
  const bioLogin = async (aPayload: loginProps) => {
    const res = await pinLogin(aPayload);

    if (res.code !== 200) {
      ErrorRes({ code: res.code, msg: res.msg, path: 'pinSignIn', isBack: false });
      return;
    }
    if (!res.data) {
      // navigate('/wallet');
      return;
    }
    checkCacheStatus();
    updatePushToken();
    setAuthInfo(res!.data.value);
    keepEmail(aPayload.email, false, 'bio');
    localSetStorage(res!.data);
    navigate('/wallet');
  };

  //     } else if (val === '0') {
  //       toast.error('지문 등록 후 사용해 주세요.');
  //     }
  //   } else if (bioType.current === 'auth') {
  //     // 1:인증성공,2:인증등록성공(안드로이드용),0:인증실패
  //     if (val === '1' || val === '2') {
  //       toast.success('성공'); //넘어온 인증값 확인
  //     } else {
  //       toast.error('인증에 실패 하였습니다.');
  //     }
  //   }
  // };
  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          p: 3,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
        }}
      >
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 0, top: 0, p: 0 }}>
          <Close />
        </IconButton>

        <Box>
          <Typography variant="h5" fontWeight={700} mb={3}>
            {t('validation.otherLogin')}
          </Typography>
          <Stack direction="row" gap={2}>
            <Button
              onClick={() => {
                navigate('/pinSignIn');
              }}
              fullWidth
              size="large"
              variant="contained"
            >
              {t('button.pinLogin')}
            </Button>
            {/* { <Button
              onClick={() => {
                // navigate('/pinSignIn')
                bioType.current = 'auth';
                bio_auth(false);
              }}
              fullWidth
              size="large"
              variant="contained"
            >
            <Button onClick={bioAuth} fullWidth size="large" variant="contained">
              지문으로 로그인
            </Button> } */}
          </Stack>
        </Box>
      </Box>
    </Drawer>
  );
}

export default LoginOtherDrawer;
